import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PageHead } from "../GtaxShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gtax`;

export default function GtaxContact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, f);
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || "Please check your details and try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="gtax-contact-page">
      <PageHead eyebrow="Contact" title="Speak with the Association." sub="Membership enquiries, introductions and member services. A member of our team will respond personally." />
      <section className="pb-28">
        <div className="gx-wrap grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5 space-y-8">
            <div className="gx-photo h-72"><img src="/gtax/bar.jpg" alt="Gold bar" /></div>
            <div><div className="gx-eyebrow">Office</div><div className="gx-serif text-2xl mt-2">DFI Holdings · Abu Dhabi, UAE</div></div>
            <div><div className="gx-eyebrow">Hours</div><div className="gx-serif text-2xl mt-2">Monday – Friday · 09:00 – 18:00 GST</div></div>
          </div>
          {sent ? (
            <div className="lg:col-span-7 gx-card p-12" data-testid="gtax-contact-success">
              <h2 className="gx-serif text-4xl">Thank you.</h2>
              <p className="mt-4 text-[color:var(--mute)]">Your message has been received. We will be in touch shortly.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="lg:col-span-7 gx-card p-10 space-y-8" data-testid="gtax-contact-form">
              {[["name", "Full name", "text"], ["email", "Email", "email"], ["subject", "Subject", "text"]].map(([k, l, t]) => (
                <div key={k}>
                  <label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">{l}</label>
                  <input type={t} required={k !== "subject"} value={f[k]} onChange={set(k)} className="w-full py-3 text-lg" data-testid={`gtax-contact-${k}`} />
                </div>
              ))}
              <div>
                <label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">Message</label>
                <textarea required rows={5} value={f.message} onChange={set("message")} className="w-full p-4 mt-3 text-lg" data-testid="gtax-contact-message" />
              </div>
              <button disabled={busy} className="gx-btn disabled:opacity-60" data-testid="gtax-contact-submit">{busy ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
